import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";

export const corporate = type => {
  document.title = 'トランクルームをお探しなら『ハローストレージ』【公式】｜会社概要';
  return (
    <div className="container">
      {breadcrumbs(type, [{ text: "会社概要" }])}

      <div className="corporate">
        <h2 id="contentsHead">会社概要</h2>
        <div className="box02">
          <h3>会社概要</h3>
          <div className="box02Txt">
            <dl className="tokusho">
              <dt>会社名</dt>
              <dd>
                エリアリンク株式会社 （英文社名：AREALINK CO.,LTD.）
                <br />
                <a href="https://www.arealink.co.jp/" target="_blank">
                  https://www.arealink.co.jp/
                </a>
              </dd>
              <dt>所在地</dt>
              <dd>
                〒101-0021
                <br />
                東京都千代田区外神田4-14-1 秋葉原UDXビル20階
              </dd>
              <dt>設立</dt>
              <dd>1995年4月</dd>
              <dt>資本金</dt>
              <dd>6,111,539千円</dd>
              <dt>代表者</dt>
              <dd>代表取締役会長　林尚道<br />代表取締役社長　鈴木貴佳</dd>
              <dt>従業員数</dt>
              <dd>
                71名（役員、臨時従業員、派遣社員を除く）
                <br />
                （2022年12月31日現在）
              </dd>
              <dt>決算期</dt>
              <dd>12月</dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/static/corporate.jsx